/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { trailLogout } from '../../../utils/activityTrail';
import { Link, useHistory } from 'react-router-dom';
import util from "../../../utils/util";
//import {If} from '../Controls';
import { Dropdown, Avatar } from 'antd';
import Manual from './IMS USER Manual.pdf'
import downloa from "./download-solid.svg"
import user from './circle-user-solid.svg'
import {
    DownOutlined, UserOutlined, LogoutOutlined
} from '@ant-design/icons';
let $ = window.$;


export default function Header() {
    const history = useHistory();
    const toggleSidebarCollapse = (e) => {
        e.preventDefault();
        if ($("body").hasClass("page-sidebar-closed")) {
            $("body").removeClass("page-sidebar-closed");
        } else {
            $("body").addClass("page-sidebar-closed");
        }
    }

    const toggleResponsiveSidebarCollapse = (e) => {
        e.preventDefault();
        if ($("body").hasClass("page-sidebar-mobile-offcanvas-open")) {
            $("body").removeClass("page-sidebar-mobile-offcanvas-open");
            $(".page-sidebar-cover").hide();
        } else {
            $("body").addClass("page-sidebar-mobile-offcanvas-open");
            $(".page-sidebar-cover").show();
        }
    }

    useEffect(() => {
        // eslint-disable-next-line
    }, []);

    const userDDItems = [
        { label: <Link to="/profile"><UserOutlined /> My Profile</Link>, key: '1' },

        { label: <div className="cpointer" onClick={(e) => { trailLogout(util.getLoggedName()); util.logout(e, history); }}><LogoutOutlined /> Logout</div>, key: '3', visible: 'Y' },
    ];

    const onButtonClick = () => {
        fetch(Manual).then((response) => {
            response.blob().then((blob) => {
            
                // Creating new object of PDF file
                const fileURL =
                    window.URL.createObjectURL(blob);
                    
                // Setting various property values
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = "IMS USER Manual.pdf";
                alink.click();
            });
        });
    };

    return (
        <div className="page-header navbar navbar-fixed-top d-print-none">
            <div className="d-flex h-100">
                <div className="page-logo my-auto">
                    <img src="assets/img/elogo.png" alt="logo" width="80" className="logo-default" style={{ marginTop: '-8px' }} />

                    {/* <span className="m-0 font-green-sharp inblock pt10 fs18 bold600">INVENTORY MANAGEMENT</span> */}
                    <div className="menu-toggler sidebar-toggler" onClick={toggleSidebarCollapse}> <span></span> </div>
                </div>

                <div className="my-auto font-green uc">
                    Health Standards Management
                </div>
        <div className='my-auto ml-auto  bg-white badge-pill'>
        <div className=" h-100 p-2">
                    <Dropdown
                        placement="bottomRight"
                        trigger={["click"]}
                        menu={{ items: userDDItems }}
                    >
                        <div className="cpointer d-flex align-items-center">
                            <div className="">
                                {/* <Avatar icon={<UserOutlined />} style={{ color: "#ffffff" }} /> */}
                               <img src={user} alt='user' height={20}/>
                            </div>
                            <div className="ml-auto d-flex align-items-center pl10 ">
                                <div className="ellipsis pr10 font-weight-bold" style={{ maxWidth: 100, color: '#2d5f8b' }}>
                                    {/* <Tooltip title={util.getLoggedName()}> */}
                                    {util.getLoggedName()}
                                    {/* </Tooltip> */}
                                </div>
                                <div>
                                    <DownOutlined className="fs13 font-weight-bold" style={{ color: '#2d5f8b' }} />
                                </div>
                            </div>
                        </div>
                    </Dropdown>
                </div>

        </div>
  
                <div className="my-auto pl20">
                    <a href="/" className="my-auto menu-toggler responsive-toggler" data-toggle1="collapse" data-target1=".navbar-collapse" onClick={toggleResponsiveSidebarCollapse}>
                        <span></span>
                    </a>
                </div>

            </div>
        </div>
    )
}